import ExtendableError from 'es6-error';
class ExampleError extends ExtendableError {
    // constructor is optional; you should omit it if you just want a custom error
    // type for inheritance and type checking
    constructor(message = 'Default message'){
        super(message);
    }
}
export class AuthError extends ExtendableError {
    constructor(url, status, reason, message = 'Authentification problem'){
        super(message);
        this.status = status;
        this.code = 'E_AUTH';
        this.url = url;
        this.reason = reason;
    }
}
export class NetworkError extends ExtendableError {
    constructor(url, message = 'Network Error'){
        super(message);
        this.code = 'E_NETWORK';
        this.url = url;
    }
}
export class TimeoutError extends ExtendableError {
    constructor(url, timeout, message = 'Timeout Error'){
        super(message);
        this.code = 'E_TIMEOUT';
        this.url = url;
        this.timeout = timeout;
    }
}
export class NotfoundError extends ExtendableError {
    constructor(url, message = '404 NotFound'){
        super(message);
        this.code = 'E_NOTFOUND';
        this.url = url;
    }
}
export class CancelError extends ExtendableError {
    constructor(message = 'Request canceled'){
        super(message);
        this.code = 'E_CANCEL';
    }
}
export class UnloadedDomainError extends ExtendableError {
    constructor(dname){
        super(`Domain ${dname} not loaded`);
        this.code = 'E_DOMAIN_UNLOADED';
        this.dname = dname;
    }
}
